import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const FILTER_KEY = 'quick_filter_color';

export const useQuickFilterSectionColorOpenedState = () => {
  return useOpenedStateManager(FILTER_KEY);
};
